import React from "react";
import { useSelector } from "react-redux";
import { selectUserResetPending } from "slices/authSlice";
import ForgotPasswordCode from "./ForgotPasswordCode";
import ForgotPasswordEmail from "./ForgotPasswordEmail";

const ForgotPasswordForm = ({ postSignIn }) => {
  const userResetPending = useSelector(selectUserResetPending);
  return (
    <div className="slideContainer">
      <div className={userResetPending ? "formSlideLeft" : ""}>
        <ForgotPasswordEmail />
        <ForgotPasswordCode postSignIn={postSignIn} />
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
